// @mui
import {
  Table,
  TableCell,
  TableRow,
  TableBody,
  Grid,
  Box,
  Typography,
  TextField,
  Avatar,
  Chip,
} from "@mui/material";
import Iconify from "../iconify";
import OptionPreview from "./OptionPreview";
import { useNavigate } from "react-router-dom";
import DeleteDialog from "./DeleteDialog";
import { useState } from "react";
import { pink, deepPurple, orange, brown, cyan } from "@mui/material/colors";
// ----------------------------------------------------------------------

export default function QuestionsTable(props) {
  const navigate = useNavigate();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [questionIndex, setQuestionIndex] = useState(null);
  return (
    <>
      {props.questions.length === 0 ? (
        <Typography variant="p" gutterBottom>
          No questions
        </Typography>
      ) : (
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableBody>
            {props.questions.map((row, index) => (
              <TableRow
                key={`${props.lang}-row-${index}`}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  <Box sx={{ p: 0, fontSize: 18 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={1}>
                        <Avatar sx={{ bgcolor: orange[500] }}>
                          {index + 1}
                        </Avatar>
                      </Grid>
                      <Grid item xs={11}>
                        {props.lang ? row[`title_` + props.lang] : row.title_en}{" "}
                        {`(${row.points} pts)`}
                      </Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ pt: 2, pb: 2, fontSize: 12 }}>
                    {props.lang
                      ? row[`description_` + props.lang]
                      : row.description_en}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 5,
                    }}
                  >
                    <Grid container spacing={2}>
                      {row?.custom_value ? (
                        <TextField
                          type="number"
                          disabled={true}
                          value={row.custom_value}
                        ></TextField>
                      ) : null}
                      {row?.options
                        ? row.options.map((option, index) => (
                            <Grid item xs={3} key={index}>
                              <OptionPreview
                                option={option}
                                lang={props.lang}
                                optionClickHandler={props.optionClickHandler}
                                questionId={row.question_id}
                                question={row}
                                matchStats={props.matchStats ?? null}
                              />
                            </Grid>
                          ))
                        : null}
                    </Grid>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 5,
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} key={index}>
                        {row.bonus_options &&
                          row.bonus_options.map((option, index) => (
                            <Chip
                              sx={{
                                m: 1,
                                border:
                                  option.is_correct && option.is_correct
                                    ? "3px solid #5DB661"
                                    : "none",
                              }}
                              onClick={() =>
                                props.bonusOptionClickHandler(
                                  row.question_id,
                                  option.label
                                )
                              }
                              label={option.label}
                            />
                          ))}
                      </Grid>
                    </Grid>
                  </Box>
                </TableCell>
                {props.showActions ? (
                  <TableCell align="right">
                    <Iconify
                      icon="eva:edit-2-outline"
                      onClick={() =>
                        navigate(
                          `/dashboard/pickem/question?pickem_id=${props.pickemId}&question_id=${row.question_id}`
                        )
                      }
                      sx={{ cursor: "pointer", margin: 3 }}
                    />
                    <Iconify
                      icon="eva:trash-2-outline"
                      onClick={() => {
                        setOpenConfirm(true);
                        setQuestionIndex(index);
                      }}
                      sx={{ cursor: "pointer", margin: 3 }}
                    />
                  </TableCell>
                ) : null}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      <DeleteDialog
        openConfirm={openConfirm}
        setOpenConfirm={setOpenConfirm}
        questionIndex={questionIndex}
        deleteGameHandler={props.deleteQuestionHandler}
        type={"question"}
      />
    </>
  );
}
